module.exports = __webpack_public_path__ + "img/halloween-bee.e2383056.svg";